import { render, staticRenderFns } from "./HotJobCard.vue?vue&type=template&id=815cf3b4&scoped=true"
import script from "./HotJobCard.vue?vue&type=script&lang=js"
export * from "./HotJobCard.vue?vue&type=script&lang=js"
import style0 from "./HotJobCard.vue?vue&type=style&index=0&id=815cf3b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815cf3b4",
  null
  
)

export default component.exports